import { render, staticRenderFns } from "./ApprovalChainTemplates.vue?vue&type=template&id=ef22bcae&"
import script from "./ApprovalChainTemplates.vue?vue&type=script&lang=js&"
export * from "./ApprovalChainTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VListItem,VSkeletonLoader})
